import { get } from 'lodash';
import { userServices } from '../services';
import { _showAlert } from '../utils';

export const fetchAllUsers = async (payload) => {
  try {
    const res = await userServices.fetchAllUsers(payload);
    return get(res, 'data', []);
  } catch (error) {
    console.log(error);
  }
};

export const updateUser = async (id, payload) => {
  try {
    const res = await userServices.updateUser(id, payload);
    return get(res, 'data', []);
  } catch (error) {
    console.log(error);
  }
};

export const fetchAllUsersById = async (id) => {
  try {
    const res = await userServices.fetchAllUsersById(id);
    return get(res, 'data', []);
  } catch (error) {
    console.log(error);
  }
};

export const loginUser = async (payload) => {
  try {
    const res = await userServices.loginUser(payload);
    return get(res, 'data', []);
  } catch (error) {
    return error;
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await userServices.deleteUser(id);
    return get(res, 'data', []);
  } catch (error) {
    console.log(error);
  }
};

export const refreshToken = async (payload) => {
  try {
    const res = await userServices.refreshToken(payload);
    return get(res, 'data', []);
  } catch (error) {
    console.log(error);
    _showAlert('Access token is not updated!', 'error');
  }
};

export const addPlaylistsToUser = async (id, payload) => {
  try {
    const res = await userServices.addPlaylistsToUser(id, payload);
    return res;
  } catch (error) {
    console.log(error);
    return { code: 'ERROR' };
  }
};

